import { render, staticRenderFns } from "./CourseStat.vue?vue&type=template&id=ed3210dc&scoped=true&"
import script from "./CourseStat.vue?vue&type=script&lang=js&"
export * from "./CourseStat.vue?vue&type=script&lang=js&"
import style0 from "./CourseStat.vue?vue&type=style&index=0&id=ed3210dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3210dc",
  null
  
)

export default component.exports